<script lang="ts">
	import type { DashWidgetEditType } from '../../dash-types';
	import DashWidgetReorderCards from '../Components/DashWidgetReorderCards.svelte';

	export let editItem: DashWidgetEditType;
</script>

<DashWidgetReorderCards bind:editItem />
